var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:{ 'header--error': _vm.blockingError.enabled }},[_c('div',{staticClass:"header__content"},[_c('FeedbackCompanyLogo',{attrs:{"color":_vm.logoStyle.color,"width":_vm.logoStyle.width}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }